import React from 'react';

// IMPORT STYLES
import './Logo.css';

// IMPORT CONSTANTS
import {
  LOGO,
  LOGO_ALT,
} from './constants';

function Logo({
  logoMod=''
}) {

  return(
      <img
        className={`logo ${logoMod}`}
        src={LOGO}
        alt={LOGO_ALT}
      />
  );
}
export default Logo;
